<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      <div class="card card-v2 mt-5">
        <div class="card-body text-center py-5">
          <!-- Icon -->
          <div class="mb-4">
            <div class="setup-incomplete-icon">
              <lucide-icon name="user-cog"></lucide-icon>
            </div>
          </div>

          <!-- Title -->
          <h2 class="mb-3 font-semibold text-primary">
            {{ 'setup_incomplete.title' | translate }}
          </h2>

          <!-- Description -->
          <p class="text-muted mb-4 max-w-400 mx-auto">
            {{ 'setup_incomplete.description' | translate }}
          </p>

          <!-- Context-specific message -->
          @if (isInternalUser) {
            <div class="alert alert-light mb-4" role="alert">
              <small class="text-muted">
                {{ 'setup_incomplete.internal_message' | translate }}
              </small>
            </div>
          } @else {
            <div class="alert alert-light mb-4" role="alert">
              <small class="text-muted">
                {{ 'setup_incomplete.hotel_message' | translate }}
              </small>
            </div>
          }

          <!-- Collapsible technical details -->
          @if (reason) {
            <div class="mb-4">
              <a href="javascript:void(0)"
                 class="text-muted small"
                 (click)="toggleDetails()">
                {{ 'setup_incomplete.see_details' | translate }}
                <lucide-icon [name]="showDetails ? 'chevron-up' : 'chevron-down'"></lucide-icon>
              </a>
              @if (showDetails) {
                <div class="mt-2">
                  <small class="text-muted">
                    {{ 'setup_incomplete.reason.' + reason | translate }}
                  </small>
                </div>
              }
            </div>
          }

          <!-- Actions -->
          <div class="d-flex justify-content-center gap-3">
            <hc-button variant="secondary" leftIcon="log-out" (clicked)="logout()">
              {{ 'common.logout' | translate }}
            </hc-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
